import { createApi } from '@reduxjs/toolkit/query/react';

import { OPPORTUNITY_CURATOR_API_URL } from 'api/APIBase';
import { handleError } from 'services/Error';
import { mapOpportunityDetails, mapOpportunitySummary } from 'services/opportunityHelpers';
import { getBaseQuery } from 'store/api/apiBaseQuery';

export const opportunityCuratorApi = createApi({
    baseQuery: getBaseQuery(OPPORTUNITY_CURATOR_API_URL),
    reducerPath: 'opportunityCuratorApi',
    endpoints: (build) => ({
        /** Gets details of opportunity */
        getOpportunity: build.query({
            query: (referralId) => `fixinator/opportunities/${referralId}`,
            transformResponse: mapOpportunityDetails,
            transformErrorResponse: (err) => {
                if (err.status === 404) {
                    handleError('Opportunity not found.', err);
                } else {
                    handleError('An error occurred retrieving opportunity details.', err);
                }
            },
        }),
        getOpportunityByTreatment: build.query({
            query: (treatmentId) => `fixinator/opportunities/by_treatment/${treatmentId}`,
            transformResponse: mapOpportunitySummary,
            transformErrorResponse: (err) => {
                if (err.status !== 404) {
                    handleError('An error occurred retrieving opportunity details.', err);
                }
            },
        }),
    }),
});

export const { useGetOpportunityQuery, useGetOpportunityByTreatmentQuery } = opportunityCuratorApi;
